import {
  PERMISSION_ACTION,
  type PermissionModule,
  modulePermissionName,
} from "@src/utility/permissions/modulePermissions";

/** Sidebar nav permission names — format: `{Module}_List`. */
export const navPerm = (module: PermissionModule) => ({
  permission: modulePermissionName(module, PERMISSION_ACTION.LIST),
});

/** Nav items that are always shown (no permission check). */
export const ALWAYS_VISIBLE_NAV_IDS = new Set([
  "dashboards",
  "analyticsDash",
]);